import React from 'react';
import './index.css';

function Article({ variant }) {


  return (
    <div className='seguridad'>
      <div className="content">
        <h3>Consejos de Seguridad</h3>
        <h4>Es muy importante recordar que el Banco nunca solicita datos personales o claves de acceso mediante correo electrónico o llamadas telefónicas.</h4>
        <div className="tabs-list">
          <h5>Correo electrónico</h5>
          <ul className="small-list">
            <li>Nunca accedas a nuestro sitio web a través de links o direcciones que recibas por correo electrónico. Siempre escribí en el navegador la dirección de la página de Internet www.bancoprovincia.com.ar.</li>
            <li>Recordá verificar el candado al lado de la dirección web para asegurarte que se trata de una página segura.</li>
          </ul>
          <h5>Redes sociales</h5>
          <ul className="small-list">
            <li>Para evitar fraudes electrónicos, corroborá que las redes sociales del Banco con las que interactúes tengan una insignia azul (tilde). Esto significa que son cuentas verificadas y que la información que encuentres en estos canales es oficial.</li>
          </ul>
          <h5>Pagos a distancia</h5>
          <ul className="small-list">
            <li>Si hacés compras a distancia de forma telefónica o por medios electrónicos, NUNCA compartas los datos de tu tarjeta con la persona que realiza la venta.</li>
            <li>Siempre solicitá un enlace de pago electrónico y verificá que la página en donde cargues los datos sea segura (identificando que en la barra de direcciones tenga el candado de seguridad).</li>
          </ul>
          <h5>Llamadas telefónicas</h5>
          <ul className="small-list">
            <li>Si recibís llamados de personas diciendo ser de bancos, tarjetas de crédito o prestadores de servicios, jamás des tus datos, información de tus tarjetas, usuarios, claves de homebanking, token o códigos.</li>
            <li>El Banco NUNCA te solicitará datos personales e información sensible de tus cuentas.</li>
          </ul>
          <h5>Pagos por internet con tarjeta de débito y/o crédito</h5>
          <ul className="small-list">
            <li>No compartas fotos de las tarjetas, datos del plástico ni código de seguridad.</li>
            <li>Solicitá el link de pago o un acceso a una web que tenga el candado de seguridad en la barra de direcciones.</li>
            <li>Tené siempre activado y actualizado el antivirus (si realizas compras desde tu compu o celu).</li>
          </ul>
        </div>
      </div>
      {
        
          (variant === 'mayores') ? (
            <>
              <div className="videos">
                <div className="embed-container">
                  <h4>Mirá estos videos</h4>
                  <div className='embed-responsive embed-responsive-16by9 with-curves'>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/mwHwP0nu9Ss?si=fAbOCKnXXeF2pyA-" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                  </div>
                </div>
                <div className="embed-container small">
                  <h5>Contraseña de la tarjeta de débito</h5>
                  <div className='embed-responsive embed-responsive-16by9 with-curves'>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/LzwphSuF1dI?si=fAbOCKnXXeF2pyA-" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                  </div>
                </div>
                <div className="embed-container small">
                  <h5>Estafas digitales</h5>
                  <div className='embed-responsive embed-responsive-16by9 with-curves'>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/chHemTSHL_o?si=fAbOCKnXXeF2pyA-" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                  </div>
                </div>
              </div>
            </>
           ) : (
              <>
                <div className="videos">
                  <div className="embed-container small">
                  <h4>Mirá estos videos</h4>
                    <h5>¿Cómo prevenir estafas ante llamadas telefónicas y operaciones presenciales ?</h5>
                    <div className='embed-responsive embed-responsive-16by9 with-curves'>
                      <iframe width="560" height="315" src="https://www.youtube.com/embed/XtmqYDAjnrc?si=fAbOCKnXXeF2pyA-" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                    </div>
                  </div>
                  <div className="embed-container small">
                    <h5>¿Cómo prevenir fraudes en el uso de internet?</h5>
                    <div className='embed-responsive embed-responsive-16by9 with-curves'>
                      <iframe width="560" height="315" src="https://www.youtube.com/embed/yiL5XlXWZxU?si=fAbOCKnXXeF2pyA-" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                    </div>
                  </div>
                </div>
              </>
           )
        
      }
    </div>
  );
}

export default Article;


